import * as Sentry from "@sentry/react";
// import { scan } from "react-scan";
import React from "react";

let isReloadingAfterChunkError = false;

// Force reload if a stale index.html causes a chunk to fail to load (e.g. after a new deploy)
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  isReloadingAfterChunkError = true;
  window.location.reload();
});
import App from "./App";
import ReactDOM from "react-dom/client";
import { Amplify } from "aws-amplify";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { PersistedStateProvider } from "./context/PersistedStateProvider";
import { NotificationProvider } from "./context/NotificationProvider";
import { ScreenProvider } from "./context/ScreenProvider";
import { BrandingProvider } from "./context/BrandingProvider";
const SENTRY_ENV_KEY = import.meta.env.VITE_SENTRY_ENV_KEY || "local";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

Sentry.init({
  dsn: "https://f0aad9dde9b93606515151800dbf180b@o4509294591016960.ingest.us.sentry.io/4509295233335296",
  environment: SENTRY_ENV_KEY,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  enabled: !navigator.userAgent.includes("Playwright"),
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // General sample rate (100% for testing) 10%.
  replaysOnErrorSampleRate: 1.0, // Sample rate 100% when sampling sessions where errors occur
  // Traces
  tracesSampleRate: 1.0,
  // TODO: Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
  enableLogs: true,
});

//Verifying functionality, needs to get integrated as a central logging hub to replace the scattered console.logs
Sentry.logger.info("Logging Initialised", { log_source: "index" });

// scan({
//   enabled: false,
// });

Amplify.configure({
  aws_cognito_region: import.meta.env.VITE_REGION,
  aws_user_pools_id: import.meta.env.VITE_USER_POOL_ID,
  aws_user_pools_web_client_id: import.meta.env.VITE_CLIENT_ID,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // don’t retry if the request was aborted
        if (error?.code === "ERR_CANCELED") return false;
        // otherwise retry up to 3 times
        return failureCount < 3;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000), // exponential backoff - a limit of 30 seconds of retries. Each retry delay is longer than the last
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode> disabled strict mode due to unexpected results with api cancellations...
  <Sentry.ErrorBoundary
    fallback={() =>
      isReloadingAfterChunkError ? null : <div>An error has occurred</div>
    }
    showDialog
  >
    <BrowserRouter>
      <NotificationProvider>
        <AuthProvider>
          <PersistedStateProvider>
            <ScreenProvider>
              <BrandingProvider>
                <QueryClientProvider client={queryClient}>
                  <App />
                </QueryClientProvider>
              </BrandingProvider>
            </ScreenProvider>
          </PersistedStateProvider>
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>,
  // </React.StrictMode>
);
